import { useQuery } from '@tanstack/react-query';

import { fetchStudentChatBulletinThreads } from '../api/routes';
import type { ChatRoomStatus } from '../api/routes';

export interface ChatBulletinThread {
  bulletin_id: number;
  title: string;
  label: string;
  date_create: string | null;
  last_activity: string | null;
  unread_count: number;
  chat_count: number;
  tutor_count: number;
}

export const useStudentChatBulletins = (
  chatStatus: ChatRoomStatus,
  enabled = true,
) => {
  const { data, isLoading } = useQuery({
    queryKey: ['student_chat_bulletin_threads', chatStatus],
    queryFn: () => fetchStudentChatBulletinThreads(chatStatus),
    staleTime: 30 * 1000,
    enabled,
  });

  const threads: ChatBulletinThread[] = (data ?? []).map((item) => ({
    bulletin_id: item.bulletin_id,
    title: item.label,
    label: item.label,
    date_create: item.date_create,
    last_activity: item.last_activity ?? null,
    unread_count: item.unread_count,
    chat_count: item.chat_count,
    tutor_count: item.tutor_count,
  }));

  return {
    threads,
    isLoading,
  };
};
